import type { ConversationOwnershipState } from './conversation-ownership-contracts'
import type { ConversationOwnershipRepository } from './conversation-ownership-repository'
import { useAggregatePoll } from './use-aggregate-poll'

export function useConversationOwnership(
  repository: ConversationOwnershipRepository | undefined,
  tenantId: string,
  aggregateId: string | null
) {
  const poll = useAggregatePoll<ConversationOwnershipState>(
    repository?.getState,
    tenantId,
    aggregateId
  )
  return {
    // A failed refresh keeps this conversation's last known ownership.
    status: poll.status === 'failed' ? ('error' as const) : poll.status,
    value: poll.value,
    refresh: poll.refresh,
    update: poll.accept,
  }
}
